module.exports = __webpack_public_path__ + "static/media/XVIh.e8a3eceb.png";